/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventNoteSavedFromJSON(json) {
    return StreemApiAnalyticEventNoteSavedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventNoteSavedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'charCount': !exists(json, 'char_count') ? undefined : json['char_count'],
        'scopeSid': !exists(json, 'scope_sid') ? undefined : json['scope_sid'],
    };
}
export function StreemApiAnalyticEventNoteSavedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'char_count': value.charCount,
        'scope_sid': value.scopeSid,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventNoteSaved.js.map